import request from '../../../axios';

export const patchBanText = async (
  payload: IUsePatchBanTextPayload,
  guid?: string,
) => {
  const {data}: {data: IResponse} = await request.patch(
    `/api/v2/shop/chat/${guid}`,
    payload,
  );
  return data;
};
